module.exports = __webpack_public_path__ + "static/media/home-hero.56a522f3.jpg";